export const shopPage_cn = {
  home: '首页',
  products: '产品',
  branches: '分支机构',
  aboutUs: '关于我们',
  basicInformation: '基本信息',
  contactUs: '联系我们',
  headOffice: '公司总部',
  Discount: '折扣优惠',
  Branches: '分支机构',
  CompanyProfile: '公司简介',
  CompanyPhoto: '公司风采',
  Certificate: '资质证书',

  News: '新闻',
  MemberID: '会员ID',
  ItisNOTaJCtransmember: 'JCtrans非会员商家',
  Comments: '评价',
  SEAFREIGHT: '海运运价',
  AIRFREIGHT: '空运运价',
  LAND_FREIGHT: '陆运运价',

  BackToMarketplaces: '返回新主站',
  BackToNewsList: '返回新闻列表',
  isAuditTime1: '此会员不在平台保障范围内', // 此会员从2023.5.22起将不在平台保障范围内
  sold_out: '商家特价商品已售罄，请浏览其他商品',

  SeaFreightAdvantageous: '优势海运',
  AirFreightAdvantageous: '优势空运',
  ShippingPartners: '合作船公司',
  AirlinePartners: '合作航空公司',
  CompanyPicture: '企业风采',
  AttendedConferences: '参会回顾',
  SponsorHistory: '赞助回顾',
  EventPhoto: '会议图片',
  History: '历史',
  Coming: '进行中',
  AdvantagePorts: '优势港口(起运港)',
  AdvantageRoutes: '优势航线',
  CooperativeCarriers: '合作承运人',
  ContactName: '联系人',
  Phone: '手机号',

  MembershipPeriod: '会员身份',
  getContacts: '获取联系方式',
  becomeMember: '成为会员查看联系方式',

  creditProfile: {
    title: '信誉档案',
    reputationLevel: '信誉评级',
    cooperation: '合作保障',
    verified: 'Verified验证',
    insurance: '保险活跃',
    manifest: '舱单活跃',
    customerTransaction: '公司客户间交易',
    customerTransactionHint: '近6个月内的会员间交易',
    totalOrders: '总订单数',
    totalSums: '总金额',
    buyerOrders: '买家订单数',
    buyerSums: '买家金额',
    sellerOrders: '卖家订单数',
    sellerSums: '卖家金额',
    valueAddedService: '增值服务',
    manifestOrders: '舱单订单数',
    insuranceOrders: '保险订单数',
  },
}

export const shopPage_en = {
  home: 'Home',
  products: 'Products',
  branches: 'Branches',
  aboutUs: 'About Us',
  Discount: 'Discount',
  basicInformation: 'Basic Information',
  contactUs: 'Contact Us',
  headOffice: 'Head office',
  Branches: 'Branches',
  CompanyProfile: 'Company Profile',
  CompanyPhoto: 'Company Photo',
  Certificate: 'Certificate',
  News: 'News',
  MemberID: 'Member ID',
  ItisNOTaJCtransmember: 'It is NOT a JCtrans member',
  Comments: 'Comments',
  SEAFREIGHT: 'SEA FREIGHT',
  AIRFREIGHT: 'AIR FREIGHT',
  LAND_FREIGHT: 'TRUCK FREIGHT',
  BackToMarketplaces: 'Back To Marketplace',
  BackToNewsList: 'Back To News List',
  isAuditTime1: 'This member is not covered by cooperation risk protection',
  sold_out: 'Merchant specials are sold out, please browse other products',
  SeaFreightAdvantageous: 'Sea Freight Routes',
  AirFreightAdvantageous: 'Air Freight Routes',
  ShippingPartners: 'Shipping Partners',
  AirlinePartners: 'Airline Partners',
  CompanyPicture: 'Company Picture',
  AttendedConferences: 'Attented History',
  SponsorHistory: 'Sponsor History',
  EventPhoto: 'Event Photo',
  History: 'History',
  Coming: 'Coming',
  AdvantagePorts: 'Core Ports',
  AdvantageRoutes: 'Advantage Routes',
  CooperativeCarriers: 'Cooperative Carriers',
  ContactName: 'Contact name',
  Phone: 'Phone',

  MembershipPeriod: 'Membership Period',
  getContacts: 'Get Contacts',
  becomeMember: 'Become Member to View Contact',

  creditProfile: {
    title: 'Credit Profile',
    reputationLevel: 'Reputation level',
    cooperation: 'Cooperation Risk Protection',
    verified: 'JC Verified',
    insurance: 'Insurance Purchase Activity',
    manifest: 'Customs Filling Activity',
    customerTransaction: 'Transactions with Customers',
    customerTransactionHint: 'Transactions between members within 6 months',
    totalOrders: 'Total Orders',
    totalSums: 'Total Sums',
    buyerOrders: 'Buyer Orders',
    buyerSums: 'Buyer Sums',
    sellerOrders: 'Seller Orders',
    sellerSums: 'Seller Sums',
    valueAddedService: 'Value-Added Services',
    manifestOrders: 'HBL Customs Filing Orders',
    insuranceOrders: 'Insurance Orders',
  },
}
